import { TabsPrimitive } from "ui";

import {
  type NavigationPartProps,
  type NavigationTabsContextValue,
} from "./NavigationTabs";
import { NavigationTabsTrigger } from "./NavigationTabsTrigger";

export function createNavigationTabsList(
  useNavigationContext: () => NavigationTabsContextValue,
) {
  return function TabsList(props: NavigationPartProps) {
    const ctx = useNavigationContext();

    return (
      <TabsPrimitive.TabsList className={props.className}>
        {ctx.tabs.map((tab) => {
          return (
            <NavigationTabsTrigger
              key={tab.tabId}
              tab={tab}
              Link={ctx.components.Link}
            />
          );
        })}
      </TabsPrimitive.TabsList>
    );
  };
}
